import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';

/**
 * Create the app theme
 * @param theme
 * @param mode
 * @returns {Theme}
 */
const createEffectiveTheme = (theme, mode) => {
  return createTheme(deepmerge({
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true
        }
      }
    },
    breakpoints: {
      xs: 0,
      sm: 479,
      md: 679,
      lg: 959,
      xl: 1167,
      values: {
        xs: 0,
        sm: 479,
        md: 679,
        lg: 959,
        xl: 1167
      }
    }
  }, theme, {
    palette: {
      mode
    }
  }));
};
export default createEffectiveTheme;